<template>
    <div :class="[ status ]">
        <div v-if="status == 'loading'" class="loader"/>
        <eleicoes-estatisticas-globais :all="global"/>
        <p v-for="note in notes" :key="note">* {{note}}</p>
        <graficos-barras 
            v-if="$state.resultados" 
            :items="$state.resultados" 
            :selected="!$state.partido ? null : { key: $state.partido }" 
            :selectable="selectable"
            @change="change"
        />
        <message v-if="msg" :title="msg"/>
        <eleicoes-estatisticas-invalidos/>
        <div class="mobile" v-if="global">
            <eleicoes-possiveis-acordos/>
            <eleicoes-composicao-parlamento/>
        </div>
        <template v-if="(!$state.realtime || $state.comparativo) && $state.comparar && comparacao">
            <h3>Variação para {{$state.comparar}}</h3>
            <graficos-barras :items="comparacao" :total="3" comparador/>
        </template>
    </div>
</template>

<script>
import { numbers, sort } from '@/core/utils'
import utils from '@/widgets/eleicoes/utils'

export default {
    props: {
        selectable: Boolean
    },
    data: () => ({
        messages: {
            error: 'Não é possível mostrar informação',
            empty: 'Não existem resultados'
        }
    }),
    methods: {
        change(res) {
            const data = !res ? null : res.opcao;
            this.$state.partido = data != this.$state.partido ? data : null;  
        }
    },
    computed: {
        notes() {
            if(!this.$state.resultados || !this.$state.resultados.length) return [];
            let notes = [];
            this.$state.resultados.forEach(item => {
                if(!item.note || notes.includes(item.note)) return;
                notes.push(item.note);
            });
            return notes;
        },
        status() {
            return utils.status(this.$state, utils.slugger(this.$state)) || (!this.$state.data ? 'loading' : null);
        },
        msg() {
            return !this.status || this.status == 'loading' ? null : (this.status == 'error' ? this.messages.error : (!this.$state.data ? this.messages.empty : (!this.$state.data.message ? (!this.$state.resultados || !this.$state.resultados.length ? this.messages.empty : null) : this.$state.data.message)));
        },
        slug() {
            return !this.$state || !this.$state.local ? null : utils.slugger({
                ...this.$state,
                ano: this.$state.comparar
            });
        },
        data() {
            if(!this.slug) return;
            return this.global ? this.legislativas : utils.data(this.$state, this.slug);
        },
        legislativas() {
            return !this.slug ? null : utils.global(this.$state, this.slug);
        },
        global() {
            return !this.$state.local ? true : `${this.$state.local}`.startsWith('99')
        },
        comparacao() {
            if(!this.data || !this.$state.data || !this.data.resultados || !this.$state.data.resultados) return;
            let res = [], old = {};
            this.data.resultados.forEach(item => (item.opcao && (old[item.opcao] = {
                ...item
            })));
            this.$state.data.resultados.forEach(item => {
                if(old[item.opcao]) {
                    let compared = {
                        ...item
                    };
                    ['mandatos', 'votos', 'percent_votantes'].forEach(prop => (compared[prop] = parseFloat(item[prop]) - parseFloat(old[item.opcao][prop])));
                    const mandatos = numbers(compared.mandatos);
                    const eleitos = `${mandatos && compared.mandatos > 0 ? '+' : ''}${!mandatos ? '' : mandatos + ' eleito' + (mandatos == 1 || mandatos == -1 ? '' : 's')}`;
                    const votos = `${compared.votos > 0 ? '+' : ''}${numbers(compared.votos)} voto${compared.votos == 1 || compared.votos == -1 ? '' : 's'}`;
                    compared.votos && res.push({
                        ...compared,
                        description: `${eleitos} ${votos}`,
                        res: Math.abs(compared.votos),
                        left: compared.opcao,
                        right: `${eleitos} ${votos}`,
                        value: compared.percent_votantes,
                        bg: utils.cor(compared.opcao)
                    });
                }
            });
            return !res || !res.length ? null : sort(res, 'percent_votantes', true);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.loading {
    min-height: 320px;
    @include medium() {
        min-height: 460px;
    }
}
p {
    color: var(--base-medium-color);
    font-size: .7rem;
    margin-top: 1rem;
    display: block;
    clear: both;
	text-align: center;
	margin-bottom: 2rem;
}
</style>